<template>
  <div class="login">
    <div class="form">
      <div class="title">
        <span>登录</span>
      </div>
      <div class="form_item">
        <label>
          <Icon type="ios-contact" style="margin-right: 4px" />用户名：
        </label>
        <div class="item_input">
          <!-- 失去焦点触发 -->
          <i-input v-model="user.username" @on-blur="getAuthCode" placeholder="输入用户名" />
        </div>
      </div>
      <div class="form_item">
        <label>
          <Icon type="md-eye" style="margin-right: 4px" />密码：
        </label>
        <div class="item_input">
          <i-input v-model="user.password" type="password" placeholder="输入密码" />
        </div>
      </div>
      <div class="form_item" v-if="keys">
        <label>
          <Icon type="ios-create" style="margin-right: 4px" />验证码：
        </label>
        <div class="item_input_yzm">
          <i-input v-model="user.authCode" @on-enter="userLogin" placeholder="输入验证码" />
        </div>
        <div class="codeImg">
          <img :src="codeImgSrc" ref="authCode" v-show="AuthCodeStatus" @click="changeAuthCode" alt />
          <span v-show="!AuthCodeStatus" @click="changeAuthCode">加载失败TnT</span>
          <Spin fix v-show="AuthCodeLoad == 1">
            <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
          </Spin>
        </div>
      </div>
      <div class="form_btn">
        <i-button type="primary" @click="userLogin" long>登录</i-button>
      </div>
      <div class="footer"></div>
    </div>
  </div>
</template>

<style lang="scss" scope>
.login {
  width: 100vw;
  height: 100vh;
  background-image: url("../assets/bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;

  .form {
    width: 31.25em; // 500px
    height: auto;
    background-color: rgba(#fff, 0.6);
    border-radius: 0.625em; // 10px
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 4px #ccc;

    .title {
      padding: 0.625em;
      color: #369;
      text-align: center;
      height: 3em;
      line-height: 3em;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #ccc;

      span {
        font-size: 1.35em;
      }
    }

    .form_item {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 0.625em 4em;
      background-color: rgba(#fff, 0.7);

      label {
        width: 6.25em; //100px
        text-align: left;
        font-size: 1em;
      }

      .item_input {
        width: calc(100% - 6.25em);
      }

      .item_input_yzm {
        width: calc(70% - 6.25em);
      }

      .codeImg {
        width: 28%;
        margin-left: 2%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          height: 100%;
        }

        span {
          cursor: pointer;
        }
      }
    }

    .form_btn {
      padding: 0.625em 10em;
      background-color: rgba(#fff, 0.7);
    }

    .footer {
      height: 1.5em;
      border-top: 1px solid #ccc;
    }
  }
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>

<script>
import { BaseUrl } from "../http/config";
import axios from 'axios';

export default {
  data() {
    return {
      user: {
        username: "",
        password: "",
        authCode: ""
      },
      codeImgSrc: "",
      keys: false, // 是否展示验证码输入模块
      AuthCodeStatus: true, // 是否加载成功 验证码请求完成状态
      AuthCodeLoad: 1 // 验证码请求状态 1为正在请求 2为已请求完成
    };
  },
  created() {
  },
  methods: {
    getAuthCode() {
      // 失去焦点获取验证码
      let username = this.user.username;
      if (username) {
        this.keys = true;
        this.codeImgSrc = encodeURI(
          BaseUrl +
          "/api/user/getAuthCode?content=" +
          JSON.stringify({
            username: this.user.username
          })
        );
        this.$nextTick(() => {
          this.$refs.authCode.onload = () => {
            this.AuthCodeStatus = true;
            this.AuthCodeLoad = 2;
          };
          this.$refs.authCode.onerror = () => {
            this.AuthCodeStatus = false;
            this.AuthCodeLoad = 2;
          };
        });
      }
    },
    changeAuthCode() {
      if (this.AuthCodeLoad == 1) {
        return false;
      }
      this.AuthCodeLoad = 1;

      this.codeImgSrc = encodeURI(
        BaseUrl +
        "/api/user/getAuthCode?content=" +
        JSON.stringify({
          username: this.user.username,
          date: new Date().getTime()
        })
      );
    },
    userLogin() {
      // 登录
      let self = this;
      if (!this.user.username || !this.user.password || !this.user.authCode) {
        this.$Message.warning("有必填项未填");
        return false;
      }
      this.$api.Login.userLogin({ content: this.user }, []).then(res => {
        if (res.code == 0) {
          res.data.rolePermissions.push("noRole");
          let park = res.data.park || [];
          if (park.length > 1) {
            self.$Local.setLocal(
              ["user", "role", "park", "parks"],
              [res.data.user, res.data.rolePermissions, res.data.park, res.data.park]
            ); // 存用户信息
            self.$router.push("/park");
          } else if (park.length == 1) {
            self.$Local.setLocal(
              ["user", "role", "bindCompanies", "park"],
              [
                res.data.user,
                res.data.rolePermissions,
                res.data.park[0].companyList,
                res.data.park
              ]
            ); // 存用户信息
            self.$router.push("/home");
          } else {
            self.$Local.setLocal(
              ["user", "role", "bindCompanies"],
              [res.data.user, res.data.rolePermissions, [res.data.company]]
            ); // 存用户信息
            if (res.data.rolePermissions.indexOf("siteDetection:page") != -1) {
              self.$router.push("/chome");
            } else {
              self.$router.push("/chome/waste");
            }

          }
          self.$store.commit("localUpdata", {
            user: res.data.user,
            role: res.data.rolePermissions,
            bindCompanies: res.data.bindCompanies
          });
          // 判断是什么账号 跳到什么页面
          // if (
          //   res.data.user.userType == "PARK_MANAGER" ||
          //   res.data.user.userType == "SUPER_MANAGER"
          // ) {
          //   self.$router.push("/home");
          // } else if (res.data.user.userType == "COMPANY_MANAGER") {
          //   let bindCompanies = [
          //     {
          //       uuid: res.data.user.uuid,
          //       name: res.data.company.name,
          //       logo: res.data.company.logoImgUrl
          //     }
          //   ];
          //   self.$Local.setLocal("bindCompanies", bindCompanies);
          //   self.$router.push("/chome");
          // }
        } else {
          this.getAuthCode();
          this.$Message.warning(res.message);
        }
      });
    },
  }
};
</script>